import config from "../../config/config";

import deleteRequest from "./base/delete";
import getRequest from "./base/get";
import patchRequest from "./base/patch";
import postRequest from "./base/post";

interface QueryParameters {
  [key: string]: any;
}

export default {
  /**
   * Create custom dashboard
   * @param data
   * @param isFileUpload
   * @returns
   */
  createCustomDashboard: (data: any = {}, isFileUpload = false): Promise<any> =>
    postRequest(
      `${config.reportApiUrl}api/super-admin/v2/custom-dashboard`,
      data,
      isFileUpload,
    ),
  /**
   * Get custom dashboard list
   * @param query
   * @returns
   */
  getCustomDashboardList: (query: QueryParameters): Promise<any> =>
    getRequest(
      `${config.reportApiUrl}api/super-admin/v2/custom-dashboard`,
      { ...query },
    ),
  /**
   * Delete custom dashboard
   * @param id
   * @returns
   */
  deleteCustomDashboard: (id: string): Promise<any> =>
    deleteRequest(
      `${config.reportApiUrl}api/super-admin/v2/custom-dashboard/${id}`,
    ),
  /**
   * Get custom dashboard details by id
   * @param id
   * @returns
   */
  getCustomDashboardDetails: (id: string): Promise<any> =>
    getRequest(`${config.reportApiUrl}api/super-admin/v2/custom-dashboard/${id}`, {}),
  /**
   * Update custom dashboard
   * @param id
   * @param data
   * @param isFileUpload
   * @returns
   */
  updateCustomDashboard: (
    id: string,
    data: any = {},
    isFileUpload = false,
  ): Promise<any> =>
    patchRequest(
      `${config.reportApiUrl}api/super-admin/v2/custom-dashboard/${id}`,
      data,
      isFileUpload,
    ),
  /**
   * Get dashboard facilities status
   * @param query
   * @returns
   */
  getDashboardFacilitiesAccountStatus: (query: QueryParameters): Promise<any> =>
    getRequest(
      `${config.reportApiUrl}api/super-admin/v2/custom-dashboard/account-stats`,
      { ...query },
    ),
  /**
   * Get top 10 facility accounts by revenue
   * @param query
   * @returns
   */
  getTop10FacilityAccountsByRevenue: (query: QueryParameters): Promise<any> =>
    getRequest(
      `${config.reportApiUrl}api/super-admin/v2/custom-dashboard/top-10-facility-accounts-by-revenue`,
      { ...query },
    ),
  /**
   * Get facility accounts growth over time
   * @param query
   * @returns
   */
  getFacilityAccountsGrowthOverTime: (query: QueryParameters): Promise<any> =>
    getRequest(
      `${config.reportApiUrl}api/super-admin/v2/custom-dashboard/facility-accounts-growth-over-time`,
      { ...query },
    ),
  /**
   * Get top 10 power consumed enconsumers
   * @param query
   * @returns
   */
  getTop10PowerConsumedEnconsumer: (query: QueryParameters): Promise<any> =>
    getRequest(
      `${config.reportApiUrl}api/super-admin/v2/custom-dashboard/top-10-enconsumer-power-consumed`,
      { ...query },
    ),
  /**
   * Get default dashboard filter
   * @returns
   */
  getDefalutDashboardFilter: (): Promise<any> =>
    getRequest(
      `${config.reportApiUrl}api/super-admin/v2/custom-dashboard/facilities-hierarchy`,
      {},
    ),
  /**
   * Get station availability status
   * @param query
   * @returns
   */
  getStationAvailabilityStatus: (query: QueryParameters): Promise<any> =>
    getRequest(
      `${config.reportApiUrl}api/super-admin/v2/custom-dashboard//station-status`,
      { ...query },
    ),

  /**
   * Get utilization rate by station
   * @param query
   * @returns
   */
  getUtilizationRateByStation: (query: QueryParameters): Promise<any> =>
    getRequest(
      `${config.reportApiUrl}api/super-admin/v2/custom-dashboard/utilization-rate-by-station`,
      { ...query },
    ),

  /**
   * Get highest revenue generating stations
   * @param query
   * @returns
   */
  getTop10StationsByRevenue: (query: QueryParameters): Promise<any> =>
    getRequest(
      `${config.reportApiUrl}api/super-admin/v2/custom-dashboard/top-10-stations-by-revenue`,
      { ...query },
    ),
  /**
   * Get peak usage hours
   * @param query
   * @returns
   */
  getPeakUsageHours: (query: QueryParameters): Promise<any> =>
    getRequest(
      `${config.reportApiUrl}api/super-admin/v2/custom-dashboard/station-peak-usage`,
      { ...query },
    ),

  /**
   * Get session type distribution
   * @param query
   * @returns
   */
  getGuestVsPaidSessions: (query: QueryParameters): Promise<any> =>
    getRequest(
      `${config.reportApiUrl}api/super-admin/v2/custom-dashboard/guest-vs-paid-sessions`,
      { ...query },
    ),
  /**
   * Get personal vs commercial sessions
   * @param query
   * @returns
   */
  getPersonalVsCommercialSessions: (query: QueryParameters): Promise<any> =>
    getRequest(
      `${config.reportApiUrl}api/super-admin/v2/custom-dashboard/personal-vs-commercial-sessions`,
      { ...query },
    ),
  /**
   * Get successful vs failed transactions
   * @param query
   * @returns
   */
  getSuccessfulVsFailedTransactions: (query: QueryParameters): Promise<any> =>
    getRequest(
      `${config.reportApiUrl}api/super-admin/v2/custom-dashboard/successful-vs-failed-transactions`,
      { ...query },
    ),
  /**
   * Get transactions over time
   * @param query
   * @returns
   */
  getTransactionsOverTime: (query: QueryParameters): Promise<any> =>
    getRequest(
      `${config.reportApiUrl}api/super-admin/v2/custom-dashboard/transactions-count-over-time`,
      { ...query },
    ),
  /**
   * Get revenue trend
   * @param query
   * @returns
   */
  getRevenueTrend: (query: QueryParameters): Promise<any> =>
    getRequest(
      `${config.reportApiUrl}api/super-admin/v2/custom-dashboard/admin-revenue-chart-stats`,
      { ...query },
    ),
  /**
   * Get revenue vs payable vs payout
   * @param query
   * @returns
   */
  getRevenueVsPayableVsPayout: (query: QueryParameters): Promise<any> =>
    getRequest(
      `${config.reportApiUrl}api/super-admin/v2/custom-dashboard/revenue-payout-payable-chart-stats`,
      { ...query },
    ),
  /**
   * Get pending vs completed payouts
   * @param query
   * @returns
   */
  getPendingVsCompletedPayouts: (query: QueryParameters): Promise<any> =>
    getRequest(
      `${config.reportApiUrl}api/super-admin/v2/custom-dashboard/payout-status-stats`,
      { ...query },
    ),
  /**
   * Get payouts over time
   * @param query
   * @returns
   */
  getPayoutsOverTime: (query: QueryParameters): Promise<any> =>
    getRequest(
      `${config.reportApiUrl}api/super-admin/v2/custom-dashboard/payout-growth-chart-stats`,
      { ...query },
    ),
  /**
   * Get top 10 facility accounts by payout volume
   * @param query
   * @returns
   */
  getTop10FacilityAccountsByPayoutVolume: (query: QueryParameters): Promise<any> =>
    getRequest(
      `${config.reportApiUrl}api/super-admin/v2/custom-dashboard/top-10-facility-accounts-by-payout-volume`,
      { ...query },
    ),
  /**
   * Get total penalties issued over time
   * @param query
   * @returns
   */
  getTotalPenaltiesIssuedOverTime: (query: QueryParameters): Promise<any> =>
    getRequest(
      `${config.reportApiUrl}api/super-admin/v2/custom-dashboard/penalty-growth-chart-stats`,
      { ...query },
    ),
  /**
   * Get penalty revenue over time
   * @param query
   * @returns
   */
  getPenaltyRevenueOverTime: (query: QueryParameters): Promise<any> =>
    getRequest(
      `${config.reportApiUrl}api/super-admin/v2/custom-dashboard/penalty-revenue-chart-stats`,
      { ...query },
    ),
  /**
   * Get penalties by station
   * @param query
   * @returns
   */
  getPenaltiesByStation: (query: QueryParameters): Promise<any> =>
    getRequest(
      `${config.reportApiUrl}api/super-admin/v2/custom-dashboard/station-penalty-revenue-stats`,
      { ...query },
    ),
};